import useAddBodyClass from './use-add-body-class';

function useWhiteBg(enabled: boolean = true) {
  useAddBodyClass('white-bg', enabled);
}

export default useWhiteBg;
